import React from 'react';
import { connect } from 'react-redux';
import URI from 'urijs';

// components
import AssistedLivingCard from '../../partials/assisted-living-card/assisted-living-card';

// modules
import styles from '../Containers.module.scss';

function AssistedLivingResult({ record, searchURI }) {
  return (
    <AssistedLivingCard
      data={record}
      className={styles.searchResult}
      searchURI={searchURI}
    />
  );
}

export default connect((state, props) => {
  const { pathname, search = {} } = state.routing.location;
  return {
    searchURI: pathname && URI(pathname).search(search).toString()
  };
}, {})(AssistedLivingResult);



// WEBPACK FOOTER //
// ./src/containers/AssistedLivingSearch/AssistedLivingSearchResult.js